@if (riskEvaluation) {
    <div class="desktop-container" [ngClass]="{'last': isLast}">
        <div>
            <span class="intro">
                <div>
                    <h3 class="p-0 m-0">{{ title }}</h3>
                    <div class="flex items-center gap-2">
                        <p>Created <b>{{ createdDateLabel }}.</b></p>
                        <p>Status: <b>{{ riskEvaluation.status | riskEvaluationStatusLabel }}</b></p>
                    </div>
                </div>
            </span>
        </div>
        <div class="form-type type-evaluation">
            Risk Evaluation
        </div>
        <div class="flex justify-content-end flex-nowrap gap-3">
            <a
                class="btn-secondary"
                [routerLink]="['/risk-management/evaluations', riskEvaluation._id]"
                (click)="$event.stopPropagation()">
                View
            </a>
        </div>
    </div>

    <div class="mobile-container" (click)="$event.stopPropagation()">
        <app-flight-card-mobile [content]="'flex'">
            <ng-container title>{{ title }}</ng-container>
            <ng-container subtitle>
                <div class="form-type type-evaluation mt-2">Risk Evaluation</div>
            </ng-container>
            <ng-container content>
                <div class="data-field">
                    <span>Created: <span class="font-bold">{{ createdDateLabel }}</span></span>
                </div>
                <div class="data-field">
                    <span>Status: <span class="font-bold">{{ riskEvaluation.status | riskEvaluationStatusLabel }}</span></span>
                </div>
            </ng-container>
            <ng-container actions>
                <a
                    class="btn-secondary w-full"
                    [routerLink]="['/risk-management/evaluations', riskEvaluation._id]"
                    (click)="$event.stopPropagation()">
                    View
                </a>
            </ng-container>
        </app-flight-card-mobile>
    </div>
}
